import { css } from 'lit';

export const ludsGradient = css`
  :host {
    --gradient-colors-45deg: linear-gradient(
      45deg,
      var(--primitive-colours-teals-teal-300, #15d0bd) 10%,
      var(--primitive-colours-blues-blue-500, #2356ce) 50%,
      var(--primitive-colours-violets-violet-500, #622dcc) 90%
    );
  }
`;
